import configs from './config.json';
import {Api} from "./Api";
import {UserApi} from "./UserApi";

export class ContactApi {
    static getContract = async (data, response, error) => {
        await Api.get(`${configs.contract}/${data}`, null, response, UserApi.getAuthorizedHeader(), error);
    }

    static getAllContract = async ( page,response, error) => {
        await Api.get(`all-contacts/${page}`, null, response, UserApi.getAuthorizedHeader(), error);
    }

    static insertContract = async (data, response, error) => {
        await Api.post(`${configs.contract}`, data, response, UserApi.getAuthorizedHeader(), error);

    }

    static deleteContract = async (id, response, error) => {
        await Api.delete(`${configs.contract}/${id}`, null, response, UserApi.getAuthorizedHeader(), error);
    }
}